export class DataCatalogTreeItem {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "itemType",
            "baseName": "itemType",
            "type": "DataCatalogTreeItemType",
            "format": ""
        },
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "parentId",
            "baseName": "parentId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "kind",
            "baseName": "kind",
            "type": "string",
            "format": ""
        },
        {
            "name": "depth",
            "baseName": "depth",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DataCatalogTreeItem.attributeTypeMap;
    }
    constructor() {
    }
}
